import React, { HTMLAttributes } from 'react';

import { BreadcrumbItem, BreadcrumbLink } from './styles';

interface LinkProps extends HTMLAttributes<HTMLElement> {
  title: string;
  path: string;
  isLast: boolean;
}

export function Link({ title, path, isLast, ...props }: LinkProps) {
  return isLast ? (
    <BreadcrumbItem className="font-semibold underline" {...props}>
      {title}
    </BreadcrumbItem>
  ) : (
    <BreadcrumbLink href={path} {...props}>
      {title}
    </BreadcrumbLink>
  );
}
